import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { RetirementContext } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

const R = Resources.Inspiration.Retirement;

export const useRetirementAgeLabels = (context: RetirementContext) => {
	const { t } = useResource();

	return {
		note: context.retirementAgeEdited
			? t(R.ageNote, {
					count: context.yearsToRetirement,
					year: context.retirementYear,
				})
			: undefined,
		formatValue: (age: number) =>
			t(R.ageValue, { age, year: context.birthYear + age }),
		minLabel: t(R.ageBound, { age: context.retirementAgeMin }),
		maxLabel: t(R.ageBound, { age: context.retirementAgeMax }),
	};
};
